exports.APP_VERSION = "1.8.2.5"; // DO NOT TOUCH
